import { type S3ConnectionCredentials } from "common";
import { createContext, type JSX, type ReactNode, useState } from "react";

interface Props {
  children?: ReactNode;
}

export interface IAmazonS3ConnectionContext {
  connectionCredentials: S3ConnectionCredentials | null;
  setConnectionCredentials: (newState: S3ConnectionCredentials) => void;
}

const initial = {
  connectionCredentials: null,
  setConnectionCredentials: (): void => {},
};

const AmazonS3ConnectionContext =
  createContext<IAmazonS3ConnectionContext>(initial);

const AmazonS3ConnectionProvider = ({ children }: Props): JSX.Element => {
  const [connectionCredentials, setConnectionCredentials] =
    useState<S3ConnectionCredentials | null>(null);

  return (
    <AmazonS3ConnectionContext.Provider
      value={{ connectionCredentials, setConnectionCredentials }}>
      {children}
    </AmazonS3ConnectionContext.Provider>
  );
};

export { AmazonS3ConnectionContext, AmazonS3ConnectionProvider };
